import { Component } from 'react';
import { Link } from 'react-router-dom';
import { RotateCw, AlertTriangle } from 'lucide-react';

import { Button } from '../ui/Button';
import { paths } from '../routes/paths';
import { APP_VERSION, APP_BUILD_ID } from '../lib/appVersion';
import { SUPPORT_EMAIL, supportMailto } from '../lib/support';

// A class is the only way to catch a render error; there is no hook equivalent.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // The dev overlay does not exist in a production build, so this is the only record.
    console.error('Page crashed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    const subject = `Dusq Admin ${APP_VERSION} (${APP_BUILD_ID}) - page error at ${window.location.pathname}`;

    return (
      <div className="flex flex-col items-center gap-4 rounded-2xl border border-border bg-background p-10 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-danger-background text-danger-foreground">
          <AlertTriangle className="h-6 w-6" />
        </span>
        <div className="flex flex-col gap-1">
          <h2 className="text-lg text-foreground">Something went wrong</h2>
          <p className="max-w-md text-sm text-gray-dark">
            This page hit an error and could not finish loading. Nothing you did caused it, and the
            rest of the admin panel still works.
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-2">
          <Button variant="primary" prefix={<RotateCw />} onClick={() => window.location.reload()}>
            Reload page
          </Button>
          <Button variant="outlined" asChild>
            <Link to={paths.dashboard.root}>Back to dashboard</Link>
          </Button>
        </div>
        <p className="text-xs text-gray-light">
          Version {APP_VERSION} · build {APP_BUILD_ID} ·{' '}
          <a
            href={supportMailto(subject)}
            className="underline underline-offset-4 hover:text-foreground"
          >
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    );
  }
}
